/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Configuration keys of a project.
*/
export class GetProjectConfigurationKeysResponse {
  /**
  * Patterns for environment classification.
  */
  'ENVIRONMENT_CLASSIFICATION_PATTERNS': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "ENVIRONMENT_CLASSIFICATION_PATTERNS",
      "baseName": "ENVIRONMENT_CLASSIFICATION_PATTERNS",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GetProjectConfigurationKeysResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

